import type { ComponentProps } from 'react';

export default function IconQuestion(props: ComponentProps<'svg'>) {
  return (
    <svg fill='currentColor' xmlns='http://www.w3.org/1999/xlink' viewBox='0 0 318 318' {...props}>
      <path d='M159,0c-52,0-95,39-95,87h47c0-22,21-39,47-39 c26,0,47,17,47,39v6c0,23-10,34-25,50c-20,21-45,48-45,105 h47c0-38,15-54,32-73c17-18,38-41,38-83v-6C254,39,211,0,159,0z' />
      <rect x='134' y='277' width='49' height='40' />
    </svg>
  );
}
